import ngTranslate from 'angular-translate';
import assign from 'lodash/assign';

import { LaunchAppExtensionPreviewServiceModule }
    from 'components/appExtensionPreview/launchAppExtensionPreview.service';
import { ExtensionServiceModule } from 'services/data/extension.service';
import { VlnBackImageModule } from 'directives/vlnBackImage.directive';

import template from './extensionStore.html';
import './extensionStore.scss';

export const ExtensionStoreModule = angular
    .module('app.components.extensionStore', [
        'ngMaterial',
        ngTranslate,
        LaunchAppExtensionPreviewServiceModule,
        ExtensionServiceModule,
        VlnBackImageModule
    ]).component('extensionStore', {
        template,
        controller: class ExtensionStoreController {
            constructor(
                launchAppExtensionModalService,
                $mdToast,
                extensionService,
                $attrs,
                $rootScope,
                $translate
            ) {
                'ngInject';

                assign(this, {
                    extensions: '',
                    extensionStoreActive: false,

                    $rootScope,
                    $mdToast,
                    launchAppExtensionModalService,
                    extensionService,
                    $attrs,
                    $translate
                });
            }

            $onInit() {
                this.getExtensions();
            }

            getExtensions() {
                this.extensionService.getExtensions(this.$attrs.app).then((extensions) => {
                    this.extensions = extensions;
                });
            }

            openExtension(extension) {
                this.launchAppExtensionModalService.launchPreview('extension', extension)
                    .then(() => {
                        return this.$translate('APPSTORE.EXTENSIONINSTALLED', {
                            EXTENSION: extension.title
                        });
                    }).then((message) => {
                        this.$mdToast.show(
                            this.$mdToast.simple()
                                .textContent(message)
                                .position('bottom left')
                                .parent('.page')
                                .hideDelay(5000)
                        );
                    });
            }
        }
    }).name;


// WEBPACK FOOTER //
// ./src/app/components/extensionStore/extensionStore.component.js